export const JOB_CURRENT_STATE_INTERVAL = 15 * 60 * 1000;
export const JOB_WEATHER_HISTORY_INTERVAL = 1 * 60 * 1000;

export const JOB_PLANTDATA_HISTORY_INTERVAL = 1 * 60 * 1000;
export const JOB_TURBINE_HISTORY_INTERVAL = 1 * 10 * 1000;

export const JOB_POWERGRIDS_HISTORY_INTERVAL = 1 * 60 * 1000;
export const JOB_VERSION_CHECK_INTERVAL = 1 * 60 * 1000;
export const JOB_VERSION_CHECK_DELAY = 2 * 1000;
export const JOB_SYSTEM_STATUS_CHECK_JOB = 1 * 60 * 1000;

export const SUPPORT_EMAIL = 'platform-support@intertrust.com';
export const SUPPORT_EMAIL_LINK = `mailto:${SUPPORT_EMAIL}?subject=Powerboard Support Request`;

export const APP_TIMEZONE = 'Europe/London';
export const TIME_FORMAT = 'HH:mm';
export const TIME_SHORT_FORMAT = 'HH';
export const TIME_LONG_FORMAT = 'HH:mm:ss';
export const DATE_FORMAT = 'MMM DD';
export const DATE_SHORT_FORMAT = 'MM/DD';
export const DATE_LONG_FORMAT = 'DD MMM YYYY';
export const DATETIME_FORMAT = `${TIME_FORMAT} ${DATE_FORMAT}`;
export const MOMENT_DATETIME = 'YYYY-MM-DD[T]HH:mm:ss[Z]';
export const DATE_AND_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const MOMENT_DATE = 'YYYY-MM-DD';

export const PATH_STATUS = 'status';
export const PATH_REPORTS = 'reports';
export const PATH_GUIDE = 'guide';
export const PATH_OPERATIONS = 'operations';
export const PATH_OFFSHORE_ACTIVITY = 'offshore-activity';
export const PATH_OPERATIONS_COMMERCIAL = 'operations-commercial';

export const SCREEN_OPERATIONS = 'OPERATIONS';
export const SCREEN_REPORTS = 'REPORTS';
export const SCREEN_OFFSHORE_ACTIVITY = 'OFFSHORE-ACTIVITY';
export const SCREEN_OPERATIONS_COMMERCIAL = 'OPERATIONS-COMMERCIAL';
export const SCREEN_STATUS = 'STATUS';

export const PARK_PORTFOLIO_KEY = 'PORTFOLIO';

export const PARK_PORTFOLIO_ITEM = {
    key: PARK_PORTFOLIO_KEY,
    screens: [SCREEN_OFFSHORE_ACTIVITY, SCREEN_OPERATIONS_COMMERCIAL],
    text: 'Portfolio',
    value: PARK_PORTFOLIO_KEY,
};

export const PARK_GROUP_NAME = 'Parks';

export const PATHNAME_STATUS = `/:park/${PATH_STATUS}`;
export const PATHNAME_GUIDE = `/:park/${PATH_GUIDE}`;
export const PATHNAME_REPORTS = `/:park/${PATH_REPORTS}`;
export const PATHNAME_OFFSHORE_ACTIVITY = `/:park/${PATH_OFFSHORE_ACTIVITY}`;
export const PATHNAME_OPERATIONS_COMMERCIAL = `/:park/${PATH_OPERATIONS_COMMERCIAL}`;
export const PATHNAME_OPERATIONS = `/:park/${PATH_OPERATIONS}`;
export const PATHNAME_INDEX = '/';

export const POUND_STERLING = '£';
export const UNIT_PERCENTAGE = '%';
export const UNIT_PCS = 'PCS';
export const UNIT_DAYS = 'Days';
export const UNIT_HOURS = 'h';

export const isMoneyUnit = (unit) => unit === POUND_STERLING;
export const isMagnitudeUnit = (unit) =>
    ![UNIT_PERCENTAGE, UNIT_PCS, UNIT_DAYS, UNIT_HOURS, UNIT_PERCENTAGE].includes(unit);

export const HideElements = {
    reportsPerformanceLink: 'reportsPerformanceLink',
    reportsMaintenanceLink: 'reportsMaintenanceLink',
};

export const CCR_OBJECT_ID = 'sys:root:pb-ccr';
